<template>
  <q-page class="bg-indigo-6">
    <div class="q-px-md absolute-center full-width">
      <div class="text-h5 pc-bold text-white text-center q-mb-lg">
        Reset password
      </div>
      <q-input
        label="Email"
        type="email"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="resetEmail"
      />
      <q-btn
        no-caps
        rounded
        color="amber-6"
        text-color="white"
        push
        class="full-width q-py-sm pc-font pc-bold q-mb-md"
        @click="sendPasswordReset(resetEmail)"
        :disable="loadingStatus"
      >
        <template v-if="!loadingStatus">
          <q-icon name="restart_alt" class="on-left" />Send request
        </template>
        <q-spinner-dots color="white" size="1em" v-else />
      </q-btn>
      <div class="row q-mb-lg">
        <router-link to="/login" style="text-decoration: none;">
          <div class="text-subtitle2 text-indigo-2 pc-bold">
            Back to Login
          </div>
        </router-link>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      resetEmail: "",
    };
  },
  methods: {
    ...mapActions("authStore", ["sendPasswordReset"]),
  },
  computed: {
    ...mapState("authStore", ["loadingStatus"]),
  },
};
</script>
